export class ModuleConfiguration {
  static moduleName = 'submission';
}



// WEBPACK FOOTER //
// ./src/app/submission/submission.module.config.ts